import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PublishDialog from 'crazyEditor/components/PublishDialog/PublishDialog';
@connect(state => ({
  isQuickPreviewMode: state.editor.isQuickPreviewMode,
}))
export default class EditorDialogs extends PureComponent {
  render() {
    const {isQuickPreviewMode} = this.props;
    if (isQuickPreviewMode) {
      return null;
    }
    return (
      <div>
        <PublishDialog />
      </div>
    );
  }
}
